import React from 'react';
import * as S from './styles';
const Avatar = ({
  href
}) => {
  return <S.Image src={href} alt="avatar" data-testid="avatar" />;
};
export default Avatar;